import { ApolloClient, ApolloLink, CombinedGraphQLErrors, HttpLink, InMemoryCache, ServerError } from '@apollo/client';
import { SetContextLink } from '@apollo/client/link/context';
import { ErrorLink } from '@apollo/client/link/error';
import { message } from 'antd';
import { loadUser } from '../oidcConfig.ts';

export const apolloFactory = () => {
  const baseUri = window._env_.API_URL;
  const graphqlUri = `${baseUri}/graphql`;
  let networkErrorTimeoutId = 0;

  const httpLink = new HttpLink({ uri: graphqlUri });

  const authLink = new SetContextLink(prevContext => {
    const user = loadUser();
    return {
      headers: {
        ...prevContext.headers,
        authorization: user?.access_token ? `Bearer ${user.access_token}` : '',
      },
    };
  });

  const errorLink = new ErrorLink(({ error, operation }) => {
    if (CombinedGraphQLErrors.is(error)) {
      error.errors.map(({ message }) => console.error(`GraphQL error: ${message}`));
    } else if (ServerError.is(error) && operation.getContext().showsOwnError) {
      console.error('Server error', error.message);
    } else if (ServerError.is(error)) {
      window.clearTimeout(networkErrorTimeoutId);
      networkErrorTimeoutId = window.setTimeout(() => {
        console.error('Server error', error.message);
        message.error(`Ein Verbindungsproblem ist aufgetreten: ${error.message}`);
      }, 300);
    } else if (error) {
      console.error(`Other Apollo error: ${error.message}`);
    }
  });

  return {
    apolloClient: new ApolloClient({
      link: ApolloLink.from([errorLink, authLink, httpLink]),
      cache: new InMemoryCache(),

      defaultOptions: {
        watchQuery: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'ignore',
        },
        query: {
          fetchPolicy: 'no-cache',
          errorPolicy: 'all',
        },
      },
    }),
  };
};
